import styled from 'styled-components';

export const UiLoginBox = styled.div`
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	flex-direction: column;
	background-color: #fff;
`;
